/**
 * Which hand the player taps with (founder, 2026-10-15): the touch controls put their buttons
 * under that thumb, and the steering on the other side. Kept per device (the You page sets it).
 */
export type Hand = "right" | "left";

const KEY = "obean.hand";

/** The player's hand on this device; right unless they chose left. */
export function hand(): Hand {
  try {
    return localStorage.getItem(KEY) === "left" ? "left" : "right";
  } catch {
    return "right"; // storage blocked: the usual layout
  }
}

export function setHand(next: Hand): void {
  try {
    if (next === "left") localStorage.setItem(KEY, "left");
    else localStorage.removeItem(KEY);
  } catch {
    // Storage blocked: the choice lasts until the page closes.
  }
}

/**
 * The swipe bar's slots from left to right (ADR 0023): a game lists its buttons from the thumb's
 * edge inward (Beantumble: Drop, Pass, Turn), so the first sits at the edge under the thumb and the
 * last nearest the middle. One slot stays free on the far side, for a button a game may add later.
 */
export function barSlots<T>(buttons: readonly T[], side: Hand): (T | null)[] {
  return side === "right" ? [null, ...[...buttons].reverse()] : [...buttons, null];
}
